import { getData } from '../../_helpers/getData';
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import constant from "../../_config/constant";
import "react-toastify/dist/ReactToastify.css";
import PricingPlans from "./PricingPlans";
import SubscriptionAdvantagesView from "./SubscriptionAdvantagesView";
import {subscriptionService} from '../../_services/subscription.service'
import { toast } from "react-toastify";
import PaymentMethodView from "./PaymentMethodView"



export default function SubscriptionPlans(props) {
  const [requesting, setRequesting] = useState(false);

  const decoded = getData();

  const [plans, setPlans] = useState([])
  

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [subscriptionInfo, setSubscriptionInfo] = useState(null)
  const [upcomingPlan, setUpcomingPlan] = useState(null)
  const [subscriptionTimezone, setSubscriptionTimezone] = useState(null)

  

  useEffect(() => {
    setUpcomingPlan(subscriptionInfo?.upcomingPlan)
    if(props.setSubscriptionInfo) {
      props.setSubscriptionInfo(subscriptionInfo)
    }
  }, [subscriptionInfo])

  useEffect(() => {
    setRequesting(true)
    const fetchPlans = async () => {
      try {
        const res = await subscriptionService.getSubscriptionInfo()
        if(res.status) {
          const plans = res.data.plans
          const subscription = res.data.subscription
          setPlans(plans)
          setSubscriptionInfo(subscription)
          setUpcomingPlan(subscription.upcomingPlan)
          setSubscriptionTimezone(res.data.timezone)
        } else {
          console.log(res.message);
          toast.error("Something went wrong!!");
        }
      } catch (error) {
        console.log(error);
        toast.error("Something went wrong!!");
      }
      setRequesting(false);
    };
    fetchPlans();
  }, []);


  return (
    
    <div className="flex flex-col tw-mt-8">
      <PricingPlans 
        plans={plans}
        selectedPlan={selectedPlan}
        setSelectedPlan={setSelectedPlan}
        activePlan={subscriptionInfo?.planId}
        upcomingPlan={upcomingPlan}
        setUpcomingPlan={setUpcomingPlan}
        subscriptionInfo={subscriptionInfo}
        setSubscriptionInfo={setSubscriptionInfo}
        timezone={subscriptionTimezone}
      />
      {selectedPlan && <PaymentMethodView selectedPlan={selectedPlan}  setSelectedPlan={setSelectedPlan} subscriptionInfo={subscriptionInfo} setSubscriptionInfo={setSubscriptionInfo}/>}
      <div className="tw-mt-4 md:tw-mt-9">
        <SubscriptionAdvantagesView/>
      </div>
    </div>
  );
}
